import axios from "axios";
import {hostWithPrefix} from "../Constructor/common/ApiCommon";

export function getDatasourcesByStationId(id) {
    return  axios({
        url: 'http://'
            + hostWithPrefix
            + '/datasourcesByStationId/'
            + id,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}